import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withNavigationErrorHandler,
  withViewTransitions,
} from '@angular/router';
import { routes } from '../app.routes';
import { handleNavigationError } from './route-error-handler.provider';

export const routerProvider = provideRouter(
  routes,
  withNavigationErrorHandler(handleNavigationError),
  withInMemoryScrolling({
    scrollPositionRestoration: 'top',
  }),
  withComponentInputBinding(),
  withViewTransitions(),
);
